import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  root: {},
  listGrid: {
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: theme.spacing(0),
    },
  },
}));

const ClubsAndExtracurricularActivities = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const location = useLocation();
  const targetRef = useRef();

  useEffect(() => {
    if (targetRef && location.hash === '#clubs-and-extracurricular-activities') { 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementPosition = targetRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition - bodyRect - 150;

      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      }); 

      // targetRef.current.scrollIntoView({
      //   behavior: 'smooth'
      // });
    }
    
  }, [location.hash]);

  return (
    <div ref={targetRef} className={clsx(classes.root, className)} {...rest}>
      <SectionHeader
        title={
          <span>
            Clubs and Extracurricular Activities
          </span>
        }
        subtitle="For students in our program who are interested in specific academic topics, social activities or career subjects, Englewood Online High School offers a variety of online extracurricular clubs and activities to suit each and every student's needs. This is a great way for students to start exploring diverse interests during their high school years."
        fadeUp
        titleVariant="h3"
      />
      <Grid container justify="center">
        {data.map((item, index) => (
          <Grid
            key={index}
            item
            container
            spacing={isMd ? 4 : 2}
            data-aos={'fade-up'}
            alignItems="center"
            justify="space-between"
            direction={index % 2 === 1 ? 'row-reverse' : 'row'}
            className={classes.listGrid}
          >
            <Grid item xs={12} sm={6}>
              <SectionHeader
                // label={item.label}
                titleVariant="h5"
                title={item.title}
                subtitle={item.description}
                align="left"
                disableGutter
              />
            {item.description2 && 
              <SectionHeader
                title=""
                titleVariant="h5"
                subtitle={item.description2}
                align="left"
                disableGutter
              />
            }
            </Grid>
            <Grid item container justify="center" xs={12} sm={6}>
              <Image
                src={item.illustration}
                alt={item.label}
                className={classes.listGrid.media}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

ClubsAndExtracurricularActivities.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default ClubsAndExtracurricularActivities;
